import React from "react";
import { BCAThemeProvider, newBcaTheme } from "@bca/ui-library";
import Pages from "./Pages";
import {
  useAnalytics,
  useOneTrustScript,
  useOneTrustFunctionScript,
  useAnalyticsScript,
} from "./hooks/scriptsHooks";

const App = () => {
  const analyticsUrl = process.env.REACT_APP_ANALYTICS_URL;
  const oneTrustDataDomainScript =
    process.env.REACT_APP_ONE_TRUST_DATA_DOMAIN_SCRIPT;
  useOneTrustScript(oneTrustDataDomainScript);
  useOneTrustFunctionScript();
  useAnalyticsScript({
    url: analyticsUrl,
    isAsync: true,
  });
  useAnalytics();
  return (
    <BCAThemeProvider theme={newBcaTheme}>
      <Pages />
    </BCAThemeProvider>
  );
};

export default App;
